<template>
  <div class="export">
    <div class="export__item">
      <div class="export__title">
        <svg
          width="582"
          height="46"
          viewBox="0 0 582 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.2 14H30.628L29.574 15.86H6.2V43.14H40.3L39.246 45H0V1.6H37.82L36.766 3.46H6.2V14ZM67.0588 15.55C69.1255 13.07 70.8821 10.962 72.3288 9.226C73.8168 7.49 75.0361 6.04333 75.9868 4.886C77.1028 3.56333 78.0328 2.468 78.7768 1.6H81.1948L68.2368 17.038C70.8821 20.2207 73.5688 23.4653 76.2968 26.772C79.0661 30.0373 81.6081 33.034 83.9228 35.762C86.5681 38.9447 89.1721 42.024 91.7348 45H83.6128L64.2068 21.874L44.8008 45H42.3828C44.5321 42.4787 46.7435 39.854 49.0168 37.126C51.0008 34.77 53.2121 32.1453 55.6508 29.252C58.0895 26.3587 60.5488 23.424 63.0288 20.448L47.2188 1.6H55.2788L67.0588 15.55ZM123.351 14C124.343 14 125.128 13.938 125.707 13.814C126.286 13.69 126.72 13.442 127.009 13.07C127.298 12.698 127.484 12.202 127.567 11.582C127.65 10.9207 127.691 10.0733 127.691 9.04C127.691 8.048 127.65 7.20066 127.567 6.498C127.484 5.754 127.298 5.17533 127.009 4.762C126.72 4.30733 126.286 3.97667 125.707 3.77C125.128 3.56333 124.343 3.46 123.351 3.46H100.411V14H123.351ZM100.411 15.86V45H94.2109V1.6H124.591C125.955 1.6 127.236 1.74466 128.435 2.034C129.634 2.282 130.688 2.69533 131.597 3.274C132.506 3.85266 133.209 4.61733 133.705 5.568C134.242 6.51866 134.511 7.676 134.511 9.04C134.511 10.404 134.242 11.5407 133.705 12.45C133.209 13.318 132.506 14 131.597 14.496C130.688 14.992 129.634 15.3433 128.435 15.55C127.236 15.7567 125.955 15.86 124.591 15.86H100.411ZM137.018 23.362C137.018 19.6007 137.803 16.3147 139.374 13.504C140.986 10.652 143.032 8.296 145.512 6.436C148.033 4.53466 150.864 3.12933 154.006 2.22C157.147 1.26933 160.268 0.793996 163.368 0.793996C166.468 0.793996 169.588 1.26933 172.73 2.22C175.871 3.12933 178.702 4.53466 181.224 6.436C183.745 8.296 185.791 10.652 187.362 13.504C188.974 16.3147 189.78 19.6007 189.78 23.362C189.78 27.082 188.974 30.3473 187.362 33.158C185.791 35.9687 183.745 38.304 181.224 40.164C178.702 42.024 175.871 43.4293 172.73 44.38C169.588 45.3307 166.468 45.806 163.368 45.806C160.268 45.806 157.147 45.3307 154.006 44.38C150.864 43.4293 148.033 42.024 145.512 40.164C143.032 38.304 140.986 35.9687 139.374 33.158C137.803 30.3473 137.018 27.082 137.018 23.362ZM143.466 22.99C143.466 25.8007 143.9 28.4873 144.768 31.05C145.636 33.6127 146.917 35.8653 148.612 37.808C150.306 39.7507 152.394 41.3007 154.874 42.458C157.354 43.574 160.206 44.132 163.43 44.132C166.654 44.132 169.506 43.574 171.986 42.458C174.466 41.342 176.532 39.8333 178.186 37.932C179.88 36.0307 181.162 33.84 182.03 31.36C182.898 28.88 183.352 26.276 183.394 23.548C183.394 20.7373 182.939 18.0507 182.03 15.488C181.162 12.884 179.88 10.6107 178.186 8.668C176.491 6.684 174.404 5.11333 171.924 3.956C169.444 2.79866 166.592 2.24066 163.368 2.282C160.144 2.32333 157.292 2.92267 154.812 4.08C152.332 5.196 150.244 6.70467 148.55 8.606C146.896 10.466 145.636 12.6567 144.768 15.178C143.9 17.658 143.466 20.262 143.466 22.99ZM203.583 14H226.523C227.515 14 228.3 13.938 228.879 13.814C229.457 13.69 229.891 13.442 230.181 13.07C230.47 12.698 230.656 12.202 230.739 11.582C230.821 10.9207 230.863 10.0733 230.863 9.04C230.863 8.048 230.821 7.20066 230.739 6.498C230.656 5.754 230.47 5.17533 230.181 4.762C229.891 4.30733 229.457 3.97667 228.879 3.77C228.3 3.56333 227.515 3.46 226.523 3.46H203.583V14ZM216.789 15.86H203.583V45H197.383V1.6H227.763C229.127 1.6 230.408 1.74466 231.607 2.034C232.805 2.282 233.859 2.69533 234.769 3.274C235.678 3.85266 236.381 4.61733 236.877 5.568C237.414 6.51866 237.683 7.676 237.683 9.04C237.683 10.404 237.414 11.5407 236.877 12.45C236.381 13.318 235.678 14 234.769 14.496C233.859 14.992 232.805 15.3433 231.607 15.55C230.408 15.7567 229.127 15.86 227.763 15.86H223.857L240.721 45H233.529L216.789 15.86ZM282.969 1.6L281.915 3.46H264.493L264.369 45H258.789V3.46H240.189L241.243 1.6H282.969ZM285.537 30.802V25.966H311.577V30.802H285.537Z"
            fill="#4A2929"
          />
          <path
            d="M320.257 14H347.165L346.111 15.86H320.257V45H314.057V1.6H354.357L353.303 3.46H320.257V14ZM362.373 45V1.6H368.573V45H362.373ZM421.461 38.366H422.081V1.6H423.941V45H418.981L384.075 3.46H382.215V45H380.355V1.6H390.647L421.461 38.366ZM451.716 10.28L442.416 26.4H462.38L453.08 10.28H451.716ZM463.434 28.26H441.424L431.69 45H429.52L454.568 1.6H455.188L480.298 45H473.106L463.434 28.26ZM528.266 38.366H528.886V1.6H530.746V45H525.786L490.88 3.46H489.02V45H487.16V1.6H497.452L528.266 38.366ZM581.897 40.97C579.417 42.582 576.73 43.8013 573.837 44.628C570.943 45.4133 568.05 45.806 565.157 45.806C562.057 45.806 558.936 45.3307 555.795 44.38C552.653 43.4293 549.822 42.024 547.301 40.164C544.821 38.304 542.775 35.9687 541.163 33.158C539.592 30.3473 538.807 27.082 538.807 23.362C538.807 19.6007 539.592 16.3147 541.163 13.504C542.775 10.652 544.821 8.296 547.301 6.436C549.822 4.53466 552.653 3.12933 555.795 2.22C558.936 1.26933 562.057 0.793996 565.157 0.793996C568.05 0.793996 570.943 1.20733 573.837 2.034C576.73 2.81933 579.417 4.018 581.897 5.63L580.099 8.792C578.363 6.76666 576.255 5.17533 573.775 4.018C571.295 2.81933 568.422 2.24066 565.157 2.282C561.933 2.32333 559.081 2.92267 556.601 4.08C554.121 5.196 552.033 6.70467 550.339 8.606C548.685 10.466 547.425 12.6567 546.557 15.178C545.689 17.658 545.255 20.262 545.255 22.99C545.255 25.8007 545.689 28.4873 546.557 31.05C547.425 33.6127 548.706 35.8653 550.401 37.808C552.095 39.7507 554.183 41.3007 556.663 42.458C559.143 43.574 561.995 44.132 565.219 44.132C568.525 44.0907 571.398 43.512 573.837 42.396C576.317 41.28 578.404 39.7507 580.099 37.808L581.897 40.97Z"
            fill="url(#paint0_linear_1_27)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_1_27"
              x1="607.514"
              y1="-4.09627"
              x2="541.482"
              y2="212.145"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#65BB9D" />
              <stop offset="0.9999" stop-color="#00784E" />
              <stop offset="1" stop-color="#65BB9D" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="export__desc">
        Сервис для взыскания долгов и оценки просроченных портфелей долгов
      </div>
      <a href="#contacts" class="export__button">Узнать больше</a>
    </div>
    <div class="export__item">
      <img src="@/assets/export-img.png" />
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.export {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  grid-gap: 14px;
  align-items: center;
  margin-bottom: 76px;
  @media (max-width: 880px) {
    grid-template-columns: 1fr;
  }
  @media (max-width: 480px) {
    margin-bottom: 30px;
    grid-gap: 0;
  }
  &__title {
    margin-bottom: 60px;
    @media (max-width: 880px) {
      svg {
        max-width: 400px;
      }
    }
    @media (max-width: 480px) {
      svg {
        max-width: 300px;
      }
      margin-bottom: 52px;
    }
  }

  &__desc {
    font-weight: 300;
    font-size: 38px;
    line-height: 46px;
    color: #000000;
    margin-bottom: 60px;
    @media (max-width: 480px) {
      font-size: 24px;
      line-height: 30px;
      margin-bottom: 52px;
    }
  }

  &__button {
    background: linear-gradient(
      254.31deg,
      #65bb9d -4.2%,
      #00784e 99.46%,
      rgba(101, 187, 157, 0) 99.47%
    );
    height: 60px;
    text-decoration: none;
    padding: 13px 44px;
    text-align: center;
    border-radius: 20px;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #ffffff;
    @media (max-width: 880px) {
      width: 100%;
    }
    @media (max-width: 480px) {
      padding: 9px 0;
      font-size: 20px;
      margin-bottom: 28px;
    }
  }

  &__item {
    img {
      max-width: 100%;
    }
    @media (max-width: 880px) {
      margin: auto;
    }
  }
}
</style>
